import {ReferenceElementFilterDto} from "../../../../../common/apis/stereotype/ReferenceDefinitionDto";
import {StereotypeDto} from "../../../../../common/apis/stereotype/StereotypeDto";
import {ArchimateElement} from "../../../../../common/archimate/ArchimateElement";
import {TranslationFunction} from "../../../../../store/localization/TranslMessasge";
import {ElementDetailTranslationKey} from "../../elementdetail/ElementDetailTranslationKey";
import {StereotypesTranslationKey} from "../StereotypesTranslationKey";

export class ReferenceElementFilterFormatter {
    static formatElementFilter(elementFilter: ReferenceElementFilterDto | undefined | null, stereotypes: StereotypeDto[], t: TranslationFunction) {
        if (!elementFilter) {
            return "";
        }

        const criteria = ReferenceElementFilterFormatter.formatFilteringCriteria(elementFilter, stereotypes, t);
        return criteria.join(", ");
    }

    static formatFilteringCriteria(elementFilter: ReferenceElementFilterDto | undefined | null, stereotypes: StereotypeDto[], t: TranslationFunction): string[] {
        if (!elementFilter) {
            return [];
        }

        const criteria: string[] = [];

        const type = ArchimateElement.findByStandardName(elementFilter.type)?.visibleName ?? elementFilter.type;
        if (type) {
            criteria.push(ReferenceElementFilterFormatter.formatCriterion(ElementDetailTranslationKey.TYPE, type, t));
        }
        if (elementFilter.stereotypeId) {
            const stereotype = stereotypes.find(stereotype => stereotype.id === elementFilter.stereotypeId);
            criteria.push(ReferenceElementFilterFormatter.formatCriterion(StereotypesTranslationKey.STEREOTYPE, stereotype?.name ?? "", t));
        }

        return criteria;
    }

    private static formatCriterion(criterionTranslKey: string, value: string, t: TranslationFunction): string {
        return `${t(criterionTranslKey)}=${value}`;
    }
}